export type Testimonial = {
  initials: string
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    initials: 'MR',
    quote:
      'I mapped out my entire coaching year in a single evening. Every session now has a clear objective and my clients can feel the difference.',
    name: 'Marcus R.',
    role: 'Functional Coach · Austin, TX',
  },
  {
    initials: 'EB',
    quote:
      'My clients progress faster because they finally follow a logical progression instead of random circuits. It changed how I coach.',
    name: 'Elena B.',
    role: 'Studio Owner · Toronto',
  },
  {
    initials: 'GF',
    quote:
      'The 3-level modification guide means I can actually run mixed-ability groups without anyone being left behind or bored.',
    name: 'Grace F.',
    role: 'Functional Coach · Manchester',
  },
  {
    initials: 'AS',
    quote:
      'As a newer coach I was overwhelmed. Functional Ready gave me a safe, professional method from day one.',
    name: 'Andre S.',
    role: 'Strength Coach · Miami',
  },
  {
    initials: 'LC',
    quote:
      'The clinical protocols let me work with back-pain clients calmly and precisely instead of guessing what to avoid.',
    name: 'Laura C.',
    role: 'Studio Owner · Sydney',
  },
  {
    initials: 'RC',
    quote:
      'Now I open the volume, pick the session, and spend my energy on coaching people instead of programming.',
    name: 'Ryan C.',
    role: 'Functional Coach · Denver',
  },
]

export const featuredTestimonials: Testimonial[] = testimonials.slice(0, 2)

export const recentPurchases: Array<{
  name: string
  city: string
  product: string
}> = [
  {
    name: 'Grace F.',
    city: 'Manchester',
    product: 'FUNCTIONAL READY™ — The Complete System',
  },
  {
    name: 'Marcus R.',
    city: 'Austin',
    product: 'FUNCTIONAL READY™ — The Complete System',
  },
  {
    name: 'Elena B.',
    city: 'Toronto',
    product: 'FUNCTIONAL READY™ — The Complete System',
  },
  {
    name: 'Laura C.',
    city: 'Sydney',
    product: 'FUNCTIONAL READY™ — The Complete System',
  },
]
